import { connect } from 'react-redux'
import resizable from 'app/connectors/resizable'

import { getIdentityActivitiesHistorySliced } from 'store/entities/identity/selectors'

import ChartBody from './ChartBody'

const mapStateToProps = (state, { isMobile }) => ({
  activities: getIdentityActivitiesHistorySliced(state).toJS(),
})

export default connect(mapStateToProps)(resizable(ChartBody))
